import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { observer, inject } from 'mobx-react';
import text from 'texts/translations';
import FrontPageTable from './Table/Table';
import { withRouter } from 'react-router-dom';
import { schemaToMongo, schemaWhere, getScui, getTranslation } from '../../utils/schemaUtil';
import { CircularProgress } from '@material-ui/core';
import { get } from 'lodash';
import color from '@material-ui/core/colors/indigo';
import Translation from '../../components/Translation/Translation';

@inject('customerCaseStore')
@inject('languageStore')
@observer
class MainPage extends Component {
  componentDidMount() {
    this.props.customerCaseStore.getMe();
    this.props.customerCaseStore.fetchSchema();
	  this.props.customerCaseStore.fetchCustomerCases('');
  }

  render() {
    
    if (this.props.customerCaseStore.caseSchemaReady !== true) {
      return <CircularProgress />; // wait until the fetch is done and the store is updated
    }

    const data = this.props.customerCaseStore.customerCases;

    let schema = schemaToMongo(this.props.customerCaseStore.caseSchema);
    let columnPaths = schemaWhere(schema, 'ui:listed');
    let columns = columnPaths.map(path => {
      let o = get(schema, path);
      let label = getTranslation(getScui(o, 'label', '', 'list'), this.props.languageStore.language);

      return {
          'name': label,
          'value': path,
          'order': getScui(o, 'listed', null)
      }
    });

    columns = columns.sort((a, b) => {
      let orderA = a['order'];
      let orderB = b['order'];

      if (orderA === orderB) return 0;
      return orderA < orderB ? -1 : 1;
    })

    const pageHeader = <Translation>header.mainTable</Translation>;
    const tableCols = columns;

    return (
      <Grid item xs={12}>
        <FrontPageTable
          pageHeader={pageHeader}
          data={data}
          tableCols={tableCols}
          linkRoute={'/case/'}
        />
      </Grid>
    );
  }
}
export default withRouter(MainPage);



// WEBPACK FOOTER //
// ./src/views/MainPage/MainPage.jsx